import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import axios from "axios";
import { Download, LogOut } from "lucide-react";
import { ThemeToggle } from "@/components/theme-toggle";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function History({ user, onLogout }) {
  const location = useLocation();
  const [downloads, setDownloads] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchDownloads();
  }, []);

  const fetchDownloads = async () => {
    try {
      const response = await axios.get(`${API}/downloads`);
      setDownloads(response.data);
    } catch (error) {
      console.error("Failed to fetch downloads", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="dashboard-container" data-testid="history-page">
      <header className="dashboard-header">
        <div className="dashboard-logo">
          <Download size={28} color="#0ea5e9" />
          <h1>Pixiv Downloader</h1>
        </div>
        <nav className="dashboard-nav">
          <Link
            to="/"
            className={`nav-link ${location.pathname === "/" ? "active" : ""}`}
            data-testid="nav-dashboard"
          >
            Dashboard
          </Link>
          <Link
            to="/history"
            className={`nav-link ${location.pathname === "/history" ? "active" : ""}`}
            data-testid="nav-history"
          >
            History
          </Link>
          <Link
            to="/settings"
            className={`nav-link ${location.pathname === "/settings" ? "active" : ""}`}
            data-testid="nav-settings"
          >
            Settings
          </Link>
          <ThemeToggle />
          <button
            onClick={onLogout}
            className="logout-button"
            data-testid="logout-button"
          >
            <LogOut size={16} style={{ display: 'inline', marginRight: '6px' }} />
            Logout
          </button>
        </nav>
      </header>

      <main className="dashboard-content">
        <section className="welcome-section">
          <h2>Download History</h2>
          <p>View all your past downloads</p>
        </section>

        {loading ? (
          <div style={{ textAlign: 'center', padding: '60px 0' }}>
            <div className="spinner"></div>
          </div>
        ) : downloads.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '60px 0' }}>
            <p style={{ color: '#64748b', fontSize: '16px' }}>No downloads yet. Start by downloading a Pixiv profile!</p>
          </div>
        ) : (
          <div className="history-grid">
            {downloads.map((download) => (
              <div key={download.id} className="history-item" data-testid="history-item">
                <div className="history-item-header">
                  <h4>{download.profile_url}</h4>
                  <span className={`status-badge ${download.status}`} data-testid="history-status">
                    {download.status.replace('_', ' ')}
                  </span>
                </div>
                <p className="history-item-meta">
                  Started: {new Date(download.created_at).toLocaleString()}
                </p>
                {download.completed_at && (
                  <p className="history-item-meta">
                    Completed: {new Date(download.completed_at).toLocaleString()}
                  </p>
                )}
                {download.status === "completed" && (
                  <p className="image-count" data-testid="image-count">{download.images.length} images downloaded</p>
                )}
              </div>
            ))}
          </div>
        )}
      </main>
    </div>
  );
}